module.exports = __webpack_public_path__ + "static/media/majorB4.070c30a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorB4.wav
// module id = 8wED
// module chunks = 0